import './style/index.scss'

import { VueQueryPlugin } from '@tanstack/vue-query'
import 'virtual:uno.css'
import { createSSRApp } from 'vue'

import App from './App.vue'
import { prototypeInterceptor, routeInterceptor } from './interceptors'
import store from './store'

export function createApp() {
  const app = createSSRApp(App)
  app.use(store)
  // 路由拦截
  app.use(routeInterceptor)
  // 兼容处理
  app.use(prototypeInterceptor)
  app.use(VueQueryPlugin)
  return {
    app,
  }
}
